/**
 * MODAL
 * Open/close modal behavior with backdrop dismiss and focus trapping.
 *
 * Expected markup:
 *   <button data-modal-open="modal-id">Open</button>
 *   <dialog id="modal-id" class="_modal">
 *     <button data-modal-close>Close</button>
 *     ...content...
 *   </dialog>
 *
 * Uses native <dialog> element for accessibility.
 * Remove this file if the project has no modals.
 */

export function init() {
  const triggers = document.querySelectorAll('[data-modal-open]');
  if (!triggers.length) return;

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const id = trigger.getAttribute('data-modal-open');
      const modal = document.getElementById(id);
      if (modal && modal.showModal) {
        modal.showModal();
      }
    });
  });

  // Close buttons inside modals
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-modal-close]');
    if (!closeBtn) return;

    const modal = closeBtn.closest('dialog');
    if (modal) modal.close();
  });

  // Backdrop click to close
  document.addEventListener('click', (e) => {
    if (e.target.tagName === 'DIALOG' && e.target.open) {
      const rect = e.target.getBoundingClientRect();
      const clickedInside =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;

      if (!clickedInside) {
        e.target.close();
      }
    }
  });
}
